<template>
  <div>
    <v-container px-0 pb-0>
      <v-layout row justify-space-between>
        <v-row>
          <v-col>
            <v-card class="pa-2 mr-2" flat min-height="340px" height="100%">
              <RulesByAmount />
            </v-card>
          </v-col>
        </v-row>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import RulesByAmount from "@/components/RulesByAmount";

export default {
  components: {
    RulesByAmount,
  },
  computed: {},
  methods: {},
  mounted() {},
  data: () => ({
    loading: false,
  }),
};
</script>

<style></style>
